// Set propio de íconos SVG inline — sin dependencia de librerías externas
// (mismo criterio que ya declaraba src/lib/modulos.ts para los glifos que
// este componente reemplaza). Trazo uniforme (currentColor, 1.75, redondeado)
// para que todos los íconos de la app compartan tamaño y grosor.
export type NombreIcono =
  | "dashboard"
  | "expedientes"
  | "clientes"
  | "partes"
  | "actuaciones"
  | "agenda"
  | "documentos"
  | "economia"
  | "usuarios"
  | "configuracion"
  | "menu"
  | "cerrar"
  | "balanza"
  | "reloj-alerta"
  | "alerta"
  | "filtro"
  | "kanban"
  | "zoom-mas"
  | "zoom-menos"
  | "expandir-colapsar"
  | "arrastrar";

const CONTENIDO: Record<NombreIcono, JSX.Element> = {
  dashboard: (
    <>
      <rect x="3" y="3" width="7.5" height="7.5" rx="1.5" />
      <rect x="13.5" y="3" width="7.5" height="7.5" rx="1.5" />
      <rect x="3" y="13.5" width="7.5" height="7.5" rx="1.5" />
      <rect x="13.5" y="13.5" width="7.5" height="7.5" rx="1.5" />
    </>
  ),
  expedientes: (
    <path d="M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7Z" />
  ),
  clientes: (
    <>
      <circle cx="12" cy="8" r="3.25" />
      <path d="M5 20c0-3.5 3-6 7-6s7 2.5 7 6" />
    </>
  ),
  partes: (
    <>
      <circle cx="9" cy="8" r="3" />
      <circle cx="16.5" cy="10" r="2.4" />
      <path d="M4 20c0-3.3 2.6-5.5 5.8-5.5 2 0 3.8 1 4.8 2.5" />
      <path d="M14.3 20c.2-2.7 2-4.3 4.4-4.6" />
    </>
  ),
  actuaciones: (
    <>
      <rect x="6" y="4" width="12" height="17" rx="2" />
      <rect x="9" y="2.4" width="6" height="3" rx="1" />
      <path d="M9 12.2l2 2 4-4.2" />
    </>
  ),
  agenda: (
    <>
      <rect x="3" y="5" width="18" height="16" rx="2" />
      <line x1="3" y1="10" x2="21" y2="10" />
      <line x1="8" y1="3" x2="8" y2="7" />
      <line x1="16" y1="3" x2="16" y2="7" />
    </>
  ),
  documentos: (
    <>
      <path d="M7 3h7l4 4v14H7V3Z" />
      <path d="M14 3v4h4" />
      <line x1="10" y1="13" x2="15" y2="13" />
      <line x1="10" y1="16.5" x2="15" y2="16.5" />
    </>
  ),
  economia: (
    <>
      <path d="M3 7.5a2 2 0 0 1 2-2h13a1.5 1.5 0 0 1 1.5 1.5v2.5H15a2.75 2.75 0 0 0 0 5.5h4.5V18a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7.5Z" />
      <circle cx="15.25" cy="12.25" r="0.9" fill="currentColor" stroke="none" />
    </>
  ),
  usuarios: (
    <>
      <circle cx="9.5" cy="8" r="3" />
      <path d="M3.5 20c0-3.3 2.7-5.5 6-5.5s6 2.2 6 5.5" />
      <circle cx="18.5" cy="16" r="1.6" />
      <line x1="18.5" y1="14.4" x2="18.5" y2="13.4" />
      <line x1="18.5" y1="18.6" x2="18.5" y2="17.6" />
      <line x1="20.1" y1="16" x2="21.1" y2="16" />
    </>
  ),
  configuracion: (
    <>
      <circle cx="12" cy="12" r="3.1" />
      <path d="M12 3.2v2.4M12 18.4v2.4M20.8 12h-2.4M5.6 12H3.2M18.1 5.9l-1.7 1.7M7.6 16.5l-1.7 1.7M18.1 18.1l-1.7-1.7M7.6 7.5 5.9 5.9" />
    </>
  ),
  menu: (
    <>
      <line x1="4" y1="7" x2="20" y2="7" />
      <line x1="4" y1="12" x2="20" y2="12" />
      <line x1="4" y1="17" x2="20" y2="17" />
    </>
  ),
  cerrar: (
    <>
      <line x1="6" y1="6" x2="18" y2="18" />
      <line x1="18" y1="6" x2="6" y2="18" />
    </>
  ),
  balanza: (
    <>
      <line x1="12" y1="3" x2="12" y2="21" />
      <line x1="8" y1="21" x2="16" y2="21" />
      <line x1="5" y1="7" x2="19" y2="7" />
      <path d="M5 7l-3.2 6.2a3.6 3.6 0 0 0 6.9 0L5 7Z" />
      <path d="M19 7l-3.2 6.2a3.6 3.6 0 0 0 6.9 0L19 7Z" />
    </>
  ),
  "reloj-alerta": (
    <>
      <circle cx="11.5" cy="13" r="7.7" />
      <path d="M11.5 8.6V13l3 2" />
      <path d="M8.7 2.2h5.6" />
    </>
  ),
  alerta: (
    <>
      <circle cx="12" cy="12" r="9" />
      <line x1="12" y1="7.5" x2="12" y2="12.5" />
      <circle cx="12" cy="16.2" r="0.9" fill="currentColor" stroke="none" />
    </>
  ),
  filtro: (
    <path d="M3.5 5h17L14 12.5v5.3l-4 2v-7.3L3.5 5Z" />
  ),
  kanban: (
    <>
      <rect x="3" y="4" width="5.5" height="16" rx="1.2" />
      <rect x="9.75" y="4" width="5.5" height="10" rx="1.2" />
      <rect x="16.5" y="4" width="5.5" height="13" rx="1.2" />
    </>
  ),
  "zoom-mas": (
    <>
      <circle cx="10.5" cy="10.5" r="7" />
      <line x1="15.8" y1="15.8" x2="21" y2="21" />
      <line x1="7.2" y1="10.5" x2="13.8" y2="10.5" />
      <line x1="10.5" y1="7.2" x2="10.5" y2="13.8" />
    </>
  ),
  "zoom-menos": (
    <>
      <circle cx="10.5" cy="10.5" r="7" />
      <line x1="15.8" y1="15.8" x2="21" y2="21" />
      <line x1="7.2" y1="10.5" x2="13.8" y2="10.5" />
    </>
  ),
  "expandir-colapsar": (
    <>
      <polyline points="8 4 4 4 4 8" />
      <polyline points="16 4 20 4 20 8" />
      <polyline points="4 16 4 20 8 20" />
      <polyline points="20 16 20 20 16 20" />
    </>
  ),
  arrastrar: (
    <>
      <circle cx="9" cy="6" r="1.1" fill="currentColor" stroke="none" />
      <circle cx="15" cy="6" r="1.1" fill="currentColor" stroke="none" />
      <circle cx="9" cy="12" r="1.1" fill="currentColor" stroke="none" />
      <circle cx="15" cy="12" r="1.1" fill="currentColor" stroke="none" />
      <circle cx="9" cy="18" r="1.1" fill="currentColor" stroke="none" />
      <circle cx="15" cy="18" r="1.1" fill="currentColor" stroke="none" />
    </>
  ),
};

export function Icono({ nombre, className = "h-5 w-5" }: { nombre: NombreIcono; className?: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.75}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      {CONTENIDO[nombre]}
    </svg>
  );
}
